var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29304 8.70711C4.90252 8.31658 4.90252 7.68342 5.29304 7.29289L9.29304 3.29289C9.68357 2.90237 10.3167 2.90237 10.7073 3.29289C11.0978 3.68342 11.0978 4.31658 10.7073 4.70711L7.41436 8L10.7073 11.2929C11.0978 11.6834 11.0978 12.3166 10.7073 12.7071C10.3167 13.0976 9.68357 13.0976 9.29304 12.7071L5.29304 8.70711Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/Chevron-Left.e698f82639865a66892549420579d2ed.svg";
export { ForwardRef as ReactComponent };